import { Box } from '@mantine/core'

import type { ShadowBoxProps } from '@/components/@Shared/ShadowBox/ShadowBox.types'

import classes from './ShadowBox.module.css'

export function ShadowBox({ children, ...props }: ShadowBoxProps) {
  return (
    <Box className={classes.shadowBoxContainer} {...props}>
      {children}
    </Box>
  )
}
